<template>
  <div style="z-index: 0">
    <svg
      class="heading"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="100%"
      height="100%"
      preserveAspectRatio="none "
    >
      <title>{{ hint }}</title>
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        :fill="fill"
        stroke="#E9ECEF"
        stroke-width="0"
      ></rect>
    </svg>
    <!--<ContainerBase
      :properties="properties"
      :childList="childList"
      :ident="ident"    
    >
    </ContainerBase>-->
  </div>
</template>

<script>
import MixinBase from "./mixin-base.js";
import MixinContainer from "./mixin-container.js";
//import ContainerBase from "./container_base.vue";

export default {
  name: "panel",

  mixins: [MixinBase, MixinContainer],
  components: {
    //ContainerBase,
  },
  props: {
    fill: {
      type: String,
      default: "#f8f9fa",
    },
  },
  data: () => ({}),
};
</script>
